import { DownloadState, getDownloadSelectors } from '@repo/core'
import { RootState } from '../../store/types'

export const convenienceTestsDraftPdfDownloadSelector = getDownloadSelectors({
  getRootPath: (state: RootState): DownloadState => state.users.convenienceTestsDraftPdfDownload,
})
